// import glo from '../../main'
import { tkParse } from '@moke/vue-tk'
export default {
  className: 'goods',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '商品名称不可为空'
      ]
    },
    {
      name: 'shopType',
      searchKey: ['name'],
      validators: [
        (val) => val ? null : '商品分类不可为空'
      ]
    },
    {
      name: 'exhibitionPrice',
      note: '价格',
      validators: [
        (val) => val ? null : '商品价格不可为空'
      ]
    },
    {
      name: 'inventory',
      validators: [
        (val) => val || val === 0 ? null : '商品库存不可为空'
      ]
    },
    {
      name: 'quota',
      tooltip: '限购开启后,限购数量将会生效'
    },
    {
      name: 'quotaCount',
      note: '限购数量',
      width: 120
      // validators: [
      //   (val) => {
      //     if (!val) return null
      //     let reg = /^[+]{0,1}(\d+)$/
      //     if (reg.test(val)) return null
      //     return '限购次数格式错误'
      //   }
      // ]
    },
    {
      name: 'isdisplay'
      // validators: [
      //   (val) => val ? null : '是否上架不可为空'
      // ]
    },
    {
      name: 'isHot',
      width: 120
    },
    {
      name: 'pictures',
      tooltip: '请上传长宽比为1:1的图片',
      validators: [
        (val) => val ? null : '商品图片不可为空'
      ]
    },
    {
      name: 'banner',
      validators: [
        (val) => val ? null : '商品轮播图不可为空'
      ]
    },
    {
      name: 'briefIntroduction',
      validators: [
        (val) => val ? null : '商品简介不可为空'
      ]
    },
    {
      name: 'details',
      validators: [
        (val) => val ? null : '商品详情不可为空'
      ]
    }
  ],
  search: [
    'name', 'shopType', 'isHot', 'quota', 'isdisplay'
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.isDelete = false
    },
    async beforeInsert ({ data }) {
      data.isDelete = false
      if (data.isHot) {
        let { data: res } = await tkParse.post('/goods/getHotTotal')
        console.log('res.total', res.total)
        if (res.total >= 10) {
          throw new Error('热门商品最多10个')
        }
      }
    },
    beforeUpdate ({ data }) {
      console.log('dddata', data)
    }
  },
  action: {
    edit: {
      type: 'row',
      text: '编辑',
      component: 'akModelEditor',
      fieldsPlus: { // 对默认使用ModelEditor的action有效，可以修改fields在编辑时的属性
        isHot: false // 隐藏一个字段
      }
    },
    delete: {
      type: 'row',
      text: '删除',
      callback: async ({ vm, record }) => {
        await vm.confirm('警告', '是否确认删除此商品，删除后无法恢复?')
        // 更改为删除并下架
        await tkParse.put(`/classes/goods/${record.objectId}`, {
          isDelete: true,
          isdisplay: false
        })
        vm.$notification['success']({
          message: '设置成功'
        })
        vm.refresh()
      }
    },
    // 上架
    grounding: {
      type: 'row',
      text: '上架',
      hidden: ({ record }) => {
        return record && record.isdisplay
      },
      callback: async ({ vm, record }) => {
        await vm.confirm('警告', '您确定要上架此商品吗?')
        try {
          await tkParse.put(`/classes/goods/${record.objectId}`, {
            isdisplay: true
          })
          vm.$notification['success']({
            message: '设置成功'
          })
          vm.refresh()
        } catch (e) {
          console.log('上架失败', e)
          vm.$notification['error']({
            message: '网络错误,请重试'
          })
        }
      }
    },
    // 下架
    OffShelf: {
      type: 'row',
      text: '下架',
      hidden: ({ record }) => {
        return record && !record.isdisplay
      },
      callback: async ({ vm, record }) => {
        await vm.confirm('警告', '您确定要下架此商品吗?')
        try {
          await tkParse.put(`/classes/goods/${record.objectId}`, {
            isdisplay: false
          })
          vm.$notification['success']({
            message: '设置成功'
          })
          vm.refresh()
        } catch (e) {
          console.log('下架失败', e)
          vm.$notification['error']({
            message: '网络错误,请重试'
          })
        }
      }
    },
    setHot: {
      type: 'row',
      text: '设置热门',
      hidden: ({ record }) => {
        return record && record.isHot
      },
      callback: async ({ vm, record }) => {
        await vm.confirm('警告', '您确定要设置此商品为热门商品?')
        try {
          let { data: res } = await tkParse.post('/goods/getHotTotal')
          if (res.total < 10) {
            await tkParse.put(`/classes/goods/${record.objectId}`, {
              isHot: true
            })
            vm.$notification['success']({
              message: '设置成功'
            })
            vm.refresh()
          } else {
            vm.$notification['warning']({
              message: '热门商品最多10个'
            })
          }
        } catch (e) {
          console.log('设为热门失败', e)
          vm.$notification['error']({
            message: '网络错误,请重试'
          })
        }
      }
    },
    cancelHot: {
      type: 'row',
      text: '取消热门',
      hidden: ({ record }) => {
        return record && !record.isHot
      },
      callback: async ({ vm, record }) => {
        await vm.confirm('警告', '您确定要为此商品取消热门?')
        try {
          await tkParse.put(`/classes/goods/${record.objectId}`, {
            isHot: false
          })
          vm.$notification['success']({
            message: '设置成功'
          })
          vm.refresh()
        } catch (e) {
          console.log('设为热门失败', e)
          vm.$notification['error']({
            message: '网络错误,请重试'
          })
        }
      }
    }
  }
}
